import React, {PureComponent} from 'react';
import {Button} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import TypeIcon from './TypeIcon';

class ItemTypePickerItem extends PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onClick(this.props);
    }

    render() {
        const {type, name} = this.props;

        return (
            <Button onClick={this.handleClick} outline color="primary" className="question-button">
                <TypeIcon type={type} height="32px" width="32px" />
                <span className="mt-2 d-block">
                    {
                        messages.type_groups[name] && <FormattedMessage {...messages.type_groups[name]} /> ||
                        messages.types[type] && <FormattedMessage {...messages.types[type]} /> ||
                        type
                    }
                </span>
            </Button>
        );
    }
}

export default ItemTypePickerItem;
